export default "__VITE_ASSET__zUMnZrix__"